import React from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router";
import {Button, Grid, Stack, Typography} from "@mui/material";
import './KoiFacade.scss'
import type {PageHeaderBack} from "~/components/main/header/PageHeader.tsx";
import {PageHeader} from "~/components/main/header/PageHeader.tsx";

type ButtonSpec = {
    type: 'btn'
    link: string
    label: string
} | {
    type: 'component'
    node: React.ReactNode
}

type Props = {
    // avatar?: React.ReactNode;
    title: string | React.ReactNode;
    subTitle?: string | React.ReactNode;
    intro?: React.ReactNode;
    back?: string | false | ButtonSpec;
    backLabel?: string;
    backClass?: string;
    onBack?: () => void;
    next?: ButtonSpec;
    nextClass?: string;
    helpContent?: React.ReactNode;
    simpleAction?: React.ReactNode;
    className?: string;
    children?: React.ReactNode;
}

export const KoiFacade: React.FC<Props> = observer((
    {
        children,
        title,
        subTitle,
        back,
        backLabel,
        backClass,
        onBack,
        next,
        nextClass,
        intro,
        helpContent,
        simpleAction,
        className
    }) => {
    const navigate = useNavigate();
    // Back control and title live in the app's top bar (Mithra 3.1 header)
    const headerBack: PageHeaderBack | undefined = (back === undefined || typeof back === 'string')
        ? {label: backLabel === undefined ? 'Back' : backLabel, onClick: () => onBack ? onBack() : navigate('' + back)}
        : (typeof back === 'object' && back.type === 'btn')
            ? {label: back.label === undefined ? 'Next' : back.label, onClick: () => navigate('' + back.link)}
            : undefined;
    const backNode = typeof back === 'object' && back.type === 'component' ? back.node : null;
    const hasActionBar = Boolean(backNode || subTitle || simpleAction || next);
    return (
        <div className={"koi-facade" + (className ? ` ${className}` : '')}>
            <PageHeader title={title} back={headerBack} helpContent={helpContent}/>
            {hasActionBar &&
                <Stack direction="row" alignItems="center" gap={2} className="header">
                    {backNode && <div className={backClass ?? 'text-center'}>{backNode}</div>}
                    {subTitle && (typeof subTitle === 'string'
                        ? <Typography variant="h4" component="h4" className="taxonomy-title">{subTitle}</Typography>
                        : subTitle)}
                    {simpleAction}
                    <Stack sx={{flexGrow: 1}}/>
                    {next &&
                        <div className={nextClass ?? 'text-center'}>
                            {next?.type === 'btn' &&
                                <Button
                                    color="primary"
                                    variant="contained"
                                    // startIcon={<ArrowBack/>}
                                    onClick={() => navigate('' + next.link)}>
                                    {next.label === undefined ? 'Next' : next.label}
                                </Button>
                            }
                            {next?.type === 'component' && next.node}
                        </div>
                    }
                </Stack>
            }
            {intro &&
                <Grid container>
                    <Grid size={2}/>
                    <Grid className="intro" size={10}>
                        {intro}
                    </Grid>
                </Grid>
            }
            {children}
        </div>
    );
});
